import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { URL_ASSETS } from 'src/app/shared/const';
import { resourcesImages } from 'src/app/shared/const/images-resources';
import { ThememodeService } from 'src/app/shared/services';
import { routesV3 } from '../../const/routes-config';

@Component({
  selector: 'app-error-page-v3',
  templateUrl: './error-page-v3.component.html',
  styleUrls: ['./error-page-v3.component.scss']
})
export class ErrorPageV3Component implements OnInit {

    isLight!: boolean;
    resources!: Array<string>;

  constructor( private thememodeService: ThememodeService,private router: Router) {
            this.resources = [
              URL_ASSETS + resourcesImages['dark-error'],
              URL_ASSETS + resourcesImages['light-error']                 
            ];
            this.isLight = this.thememodeService.getColorScheme() !== 'dark';
   }

  ngOnInit(): void {
    this.thememodeService.applyTheme('v2');
  }

  redirectToMainPage(): void {
    sessionStorage.removeItem('resourceForbidden');
    void this.router.navigate([routesV3.cloudapps.children.checkrole.route]);
  }

}
